<ng-template #ticketview>
    <ng-container *ngIf="display">
        <ion-item-sliding #itemSlider [disabled]="mode !== 'EDIT'" (ionDrag)="OnSlidingDrag($event, itemSlider)" (ionSwipe)="OnSlidingStart(itemSlider)" (click)="OnSlidingClick($event, itemSlider)">
            <ion-item>
                <div *ngIf="CanUdt" class="thumb-box" slot="start" uppDataid="ticketproduct-product-click">
                    <div class="image-box">
                        <upp-image [src]="display.photo || display.avatar"></upp-image>
                    </div>
                    <ion-badge uppDataid="ticketproduct-count-badge" color="danger">{{display.amount}}</ion-badge>
                </div>
                <div *ngIf="!CanUdt" class="thumb-box" slot="start" uppDataid="ticketproduct-product-info">
                    <div class="image-box">
                        <upp-image [src]="display.photo || display.avatar"></upp-image>
                    </div>
                    <ion-badge uppDataid="ticketproduct-count-badge" color="danger">{{display.amount}}</ion-badge>
                </div>
                <div class="options" uppDataid="ticketproduct-options-click" tabindex="0" (click)="OnShowOptions()" (keydown.enter)="OnShowOptions()" (keydown.space)="OnShowOptions()">
                    <ion-item class="name" lines="none">
                        <ion-label>{{display.amount + " x " + display.name}}</ion-label>
                        <ion-buttons *ngIf="mode === 'VIEW'" slot="end">
                            <ion-icon *ngIf="ShowOptions === true" name="chevron-up-outline"></ion-icon>
                            <ion-icon *ngIf="ShowOptions !== true" name="chevron-down-outline"></ion-icon>
                        </ion-buttons>
                        <ion-buttons *ngIf="mode === 'EDIT'" slot="end" (click)="$event.stopPropagation()">
                            <ion-icon
                                uppDataid="ticketproduct-add-button"
                                *ngIf="CanAdd"
                                name="add-circle-outline"
                                (click)="OnAddProduct($event)"
                            ></ion-icon>
                            <ion-icon
                                uppDataid="ticketproduct-del-button"
                                *ngIf="CanDel"
                                name="remove-circle-outline"
                                (click)="OnDelProduct($event)"
                            ></ion-icon>
                        </ion-buttons>
                    </ion-item>
                    <ion-item uppDataid="productticket-comments-info" *ngIf="display.comments">
                        <ion-label class="comments">"{{display.comments}}"</ion-label>
                    </ion-item>

                    <!-- PRODUCT OPTIONS -->
                    <ion-list class="options" [ngClass]="{ 'visible': ShowOptions }">
                        <ion-item uppDataid="ticketproduct-brief-title" lines="full">
                            <ion-icon *ngIf="display.available === true" slot="start" color="success" name="wine-outline"></ion-icon>
                            <ion-icon *ngIf="display.available !== true" slot="start" color="warning" name="warning-outline"></ion-icon>
                            <ion-label color="medium">
                                {{display.main}}<span *ngIf="display.weighted === true"> ({{display.weight + tr("@kilograms")}})</span>
                            </ion-label>
                            <ion-label *ngIf="display.price" color="medium" slot="end">
                                <b>{{display.price.str}}{{tr('@currency')}}</b>
                            </ion-label>
                        </ion-item>
                        <ng-container *ngFor="let option of display.options; trackBy: OptionTrack">
                            <ion-item uppDataid="ticketproduct-brief-option" lines="full">
                                <ion-icon *ngIf="option.available === true" slot="start" color="success" name="checkmark-circle-outline"></ion-icon>
                                <ion-icon *ngIf="option.available !== true" slot="start" color="warning" name="warning-outline"></ion-icon>
                                <ion-label color="medium">
                                    {{option.name}}
                                </ion-label>
                                <ion-label *ngIf="option.charge" color="medium" slot="end">
                                    <span *ngIf="option.charge.neg === false">+</span>
                                    <span *ngIf="option.charge.neg !== false">-</span>
                                    {{option.charge.str}}{{tr('@currency')}}
                                </ion-label>
                            </ion-item>
                        </ng-container>
                    </ion-list>

                    <!-- PRODUCT PRICE BRIEF -->
                    <ion-list class="prices">
                        <!-- original price -->
                        <ion-item uppDataid="ticketproduct-brief-price" [ngClass]="{ 'strike': display.reprice }">
                            <ion-label color="success">{{display.amount}} x {{(display.charge) + tr('@currency')}}</ion-label>
                            <ion-label class="price" color="success" slot="end">
                                <b>{{display.totalprice}}{{tr('@currency')}}</b>
                            </ion-label>
                        </ion-item>
                        <!-- fixed price -->
                        <ion-item uppDataid="ticketproduct-brief-fixed" *ngIf="display.isfixed" [ngClass]="{ 'strike': display.inoffer }">
                            <ion-label color="success">
                                <span *ngIf="display.onthehouse !== true">{{tr('@place_fixed_applied')}}</span>
                                <span *ngIf="display.onthehouse === true">{{tr('@place_fixed_on_the_house')}}</span>
                            </ion-label>
                            <ion-label color="success" slot="end" style="text-align:right">
                                <b>{{display.totalfixed}}{{tr('@currency')}}</b>
                            </ion-label>
                        </ion-item>
                        <!-- inoffer price -->
                        <ion-item uppDataid="ticketproduct-brief-offer" *ngIf="display.inoffer">
                            <ion-label color="success">
                                <span *ngIf="display.inoffer.ismenu !== true">{{tr('@place_offer_applied')}}</span>
                                <span *ngIf="display.inoffer.ismenu === true">{{tr(display.inoffer.name)}}</span>
                            </ion-label>
                            <ion-label color="success" slot="end" style="text-align:right">
                                <b>{{display.totaloffer}}{{tr('@currency')}}</b>
                            </ion-label>
                        </ion-item>
                    </ion-list>
                </div>
            </ion-item>

            <ion-item-options side="start" class="ticketproduct-slide-options ticketproduct-slide-options--start">
                <ion-item-option uppDataid="ticketproduct-slide-delete-option" slot="icon-only" (click)="RemoveAll($event, itemSlider)">
                    <ion-icon color="danger" name="trash-outline"></ion-icon>
                </ion-item-option>
            </ion-item-options>

            <ion-item-options side="end" class="ticketproduct-slide-options ticketproduct-slide-options--end">
                <ion-item-option uppDataid="ticketproduct-slide-calculator-option" slot="icon-only" (click)="OpenKeyboard($event, itemSlider)">
                    <ion-icon color="dark" name="calculator-outline"></ion-icon>
                </ion-item-option>
                <ion-item-option *ngIf="CanUdt" uppDataid="ticketproduct-slide-edit-option" slot="icon-only" (click)="OpenProduct($event, itemSlider)">
                    <ion-icon color="dark" name="reader-outline"></ion-icon>
                </ion-item-option>
            </ion-item-options>
        </ion-item-sliding>

        <!-- TICKETPRODUCT PAYMENT STATUS -->
        <ng-container *ngIf="display.ticket && !display.expand">
            <ion-item uppDataid="ticketproduct-done-info" *ngIf="display.donestatus" class="event left">
                <ion-label [color]="EventColor(display.donestatus)">
                    {{tr('@place_event_type_' + display.donestatus)}}
                </ion-label>
            </ion-item>
            <ion-item uppDataid="ticketproduct-paid-info" *ngIf="display.paidstatus" class="event" [ngClass]="(display.ticket.config('DirectPayment')) ? 'center' : 'right'">
                <ion-label [color]="EventColor(display.paidstatus)">
                    {{tr('@place_event_type_' + display.paidstatus)}}
                </ion-label>
            </ion-item>
        </ng-container>

        <!-- TICKETPRODUCT EXPANDED VIEW -->
        <div class="expand" *ngIf="display.expand">
            <ion-item class="title" lines="none">
                <ion-label>
                    {{tr('@ticket_items_expand')}}
                </ion-label>
                <ion-checkbox [uppDataid]="'ticketproduct-expand_' + display.name + '_selectall-check'" slot="end" (ionChange)="OnCheckAll()"></ion-checkbox>
            </ion-item>
            <ion-list class="expand-list">
                <ion-item class="expand-item" lines="none" *ngFor="let i of ExpandUnits">
                    <ion-checkbox [uppDataid="productticket-expand-product-check" slot="start" [checked]="IsChecked(i)" (ionChange)="OnCheckAny(i)"></ion-checkbox>
                    <ion-label>
                        1 x {{display.name}}
                    </ion-label>
                    <ion-label *ngIf="display.charge" slot="end" style="text-align:right">
                        <b>{{display.charge}}{{tr('@currency')}}</b>
                    </ion-label>
                </ion-item>
            </ion-list>
        </div>
    </ng-container>
</ng-template>

<ng-template #splitview>
    <div class="splitter">
        <ion-icon uppDataid="ticketproduct-del-splitter" name="close-circle-outline" (click)="OnDelSplitter($event)"></ion-icon>
    </div>
</ng-template>

<upp-visible-control mode="content" *ngIf="product">
    <ng-container *ngIf="product.IsSplitter === false" [ngTemplateOutlet]="ticketview"></ng-container>
    <ng-container *ngIf="product.IsSplitter !== false" [ngTemplateOutlet]="splitview"></ng-container>
</upp-visible-control>

<upp-ticket-keyboard
    *ngIf="product && ShowKeyboard && !product.IsSplitter"
    [ticket]="product.ticket"
    [ticketproduct]="product"
    (Updated)="OnKeyboardUpdated()"
    (Closed)="OnKeyboardClosed()"
></upp-ticket-keyboard>
